{
  "formGeneralDescription": "Este formulario permite configurar el conector PKI; actualmente, solo los PKI Microsoft son compatibles con LX CONNECT.",
  "formRootCaDescription": "El RootCA debe tener el formato .PEM y tener un tamaño inferior a 1 MB.",
  "validation": {
    "url": "La URL del servidor PKI es obligatoria",
    "urlFormat": "Formato de URL no válido",
    "login": "El identificador de acceso al servidor PKI es obligatorio",
    "password": "La contraseña del servidor PKI es obligatoria",
    "templateName": "Nombre obligatorio",
    "templateFormat": "Nombre de plantilla no válido",
    "pemFileSize": "El tamaño del archivo .PEM debe ser inferior a 1 MB",
    "pemFileMandatory": "El archivo debe ser un .PEM",
    "rootCa": "El rootCA es obligatorio.",
    "pemFileEmpty": "El archivo .PEM no debe estar vacío",
    "pemFileInvalid": "El archivo .PEM no es válido"
  },
  "testConnection": {
    "messageSuccess": "La configuración del servidor PKI es válida",
    "messageFailTitle": "Fallo de prueba de conexión",
    "messageFailConnectivity": "URL no válida",
    "messageFailAuthentication": "Par de identificador/contraseña no válido",
    "messageFailRootca": "RootCA no válido",
    "tooltip": "Pruebe la conexión",
    "ok": "OK",
    "ko": "KO"
  },
  "button": {
    "viewCertificate": "Ver los certificados"
  },
  "filters": {
    "searchByAlias": "Buscar por alias"
  },
  "noPki": "No se encontró PKI",
  "alias": "Alias",
  "type": {
    "label": "Tipo",
    "EST": "EST",
    "MICROSOFT": "Microsoft"
  },
  "url": "URL",
  "delete": {
    "title": "Eliminar la conexión PKI",
    "message": "¿Confirma la eliminación de esta conexión PKI? Ya no será posible ninguna operación con este PKI."
  },
  "form": {
    "title": {
      "create": "Crear una nueva conexión",
      "update": "Edición de conexión"
    },
    "warning": {
      "title": "Se requiere certificado PKI",
      "message": "En el almacén de llaves debe haber un certificado PKI específico con las etiquetas PKI adecuadas"
    },
    "connectionSettings": {
      "title": "Ajustes de conexión"
    },
    "login": {
      "label": "Iniciar sesión"
    },
    "password": {
      "label": "Contraseña"
    },
    "specificConfiguration": {
      "templateName": {
        "label": "Nombre de plantilla"
      },
      "retryAfter": {
        "label": "Tiempo de intervalo de reintento"
      },
      "label": {
        "urlLabel": "Nombre"
      }
    },
    "validate": {
      "create": "Añadir una conexión",
      "update": "Guardar"
    },
    "cancel": {
      "confirm": {
        "title": {
          "create": "Creación de conexión PKI",
          "update": "Actualización de conexión PKI"
        },
        "message": {
          "create": "¿Desea descartar toda la información introducida y abandonar la creación de la conexión PKI? Se perderá toda la información.",
          "update": "¿Desea descartar toda la información introducida y abandonar la actualización de la conexión PKI? Se perderá toda la información."
        }
      }
    },
    "validation": {
      "alias": {
        "required": "El alias es obligatorio",
        "max": "El alias debe tener un máximo de 50 caracteres"
      },
      "url": {
        "required": "La URL es obligatoria",
        "max": "La URL debe tener un máximo de 120 caracteres"
      },
      "type": {
        "required": "El tipo es obligatorio"
      },
      "login": {
        "required": "El inicio de sesión es obligatorio"
      },
      "password": {
        "required": "La contraseña es obligatoria"
      },
      "templateName": {
        "required": "El nombre de la plantilla es obligatorio"
      },
      "intervalTime": {
        "required": "El tiempo del intervalo de reintento es obligatorio",
        "min": "El valor no puede ser inferior a 60"
      },
      "urlLabel": {
        "max": "El nombre debe tener un máximo de 100 caracteres",
        "format": "La etiqueta debe contener únicamente caracteres alfanuméricos, guiones y guiones bajos"
      }
    },
    "trustChainsAliases": {
      "label": "Certificado de almacén de confianza asociado",
      "selectAll": "Seleccionar todos certificados",
      "selectSearchPlaceholder": "Buscar por alias",
      "selectNoResult": "No se encontraron certificados",
      "help": "El PKI se utilizará como proxy para renovar los certificados de los equipos identificados por el certificado del almacén de confianza, al tiempo que se gestiona la renovación de los certificados del almacén de claves."
    },
    "testConnection": {
      "button": "Pruebe la conexión",
      "noPassword": "Introduzca una contraseña para probar la conexión"
    }
  }
}
